<script setup lang="ts">
defineExpose({
  name: "SortUpIcon",
});
</script>

<template>
  <svg
    class="SortUpIcon"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_2046_25"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_2046_25)">
      <path
        d="M19 14L12 21L5 14H19ZM15.375 15.5H8.625L12 18.875L15.375 15.5ZM19 10H5L12 3L19 10Z"
      />
    </g>
  </svg>
</template>

<style lang="scss" scoped>
.SortUpIcon {
  width: 100%;
  height: auto;
  fill: currentcolor;
}
</style>
